import { createApp } from 'vue';
import login from './index.vue';
import updateModal from './updateModal.vue';
import changeModal from './changeModal.vue';
import addModal from './addModal.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';

const lg = {};

const createAndMount = component => {
  const app = createApp(component);
  app.use(router);
  app.use(store);
  app.use(i18n);
  // 注入 $loginModal 供组件内部使用 (例如 updateModal.vue)
  app.config.globalProperties.$loginModal = lg;
  const div = document.createElement('div');
  document.body.appendChild(div);
  return app.mount(div);
};

const instance = createAndMount(login);
const UploadInstance = createAndMount(updateModal);
const ChangeInstance = createAndMount(changeModal);
const AddInstance = createAndMount(addModal);

Object.assign(lg, {
  show() {
    instance.showLoginModal = true;
  },
  hide() {
    instance.showLoginModal = false;
  },
  showUpload() {
    UploadInstance.showUpdateModal = true;
  },
  hideUpload() {
    UploadInstance.showUpdateModal = false;
  },
  showChange() {
    ChangeInstance.showChangeModal = true;
    ChangeInstance.getAccountList();
  },
  hideChange() {
    ChangeInstance.showChangeModal = false;
  },
  showAdd() {
    AddInstance.showAddModal = true;
  },
  hideAdd() {
    AddInstance.showAddModal = false;
  },
});

export default lg;
